import React, { Component } from 'react';
import Actions from '../Actions';
import Button from '../Button';
import Empty from '../Empty';
import Icon from '../Icon';
import Overlay from '../Overlay';
import Table, { Hidden } from '../Table';
import Search from '../Search';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectSearch } from '../../store/selectors/search';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import Loader from '../Loader';
import AnnouncementForm from '../AnnouncementForm';
import { setAnnouncementFormData, clearAnnouncementFormData } from '../../store/actions/AnnouncementForm';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import moment from 'moment';
import { PATHS } from '../../common/constants';
import { Link } from 'react-router-dom';
import Announcementsview from '../../pages/Announcements/Announcementsview';
import { convertLocalTime } from '../../helpers/validationHelper';



class AnnouncementsTable extends Component {
  state = {
    showOverlay: false,
    showAnnouncementOverlay: false,
    announcementData: {}
  };

  render() {
   
    const { announcements, onSaveAnnouncements, onSearch,onDeleteAnnouncement, user,clearAnnouncementFormData, search } = this.props;
    const { showOverlay, showAnnouncementOverlay } = this.state;
    return (
      <>
        <Actions compact>
          <Search
            size="small"
            placeholder="Search Announcements..."
            onChange={onSearch}
          />
          {
            
            user && (user.roles[0].role.name === 'Admin' || user.roles[0].role.name === 'Super Admin' || user.roles[0].role.name === 'Property Developer' || user.roles[0].role.name === 'Strata Manager') ?
            <Button
            color="teal"
            label="Add Announcement"
            onClick={() => {
              this.setState({ showOverlay: true })
            }}
            icon={(
              <Icon
                glyph="building"
                weight="light"
                size="small"
              />
            )}
            size="small"
          />
          : null
          }
          
        </Actions>
        {announcements.length > 0 ?  (
          <>
            <Table
              columns={[
                {
                  label: 'Title',
                  accessor: 'title',
                  sortable: true,
                  cell: data => (
                    <Link
                      onClick={()=> {
                        this.setState({ showAnnouncementOverlay: true, announcementData: data })
                      }}
                      // to={PATHS.ANNOUNCEMENTS_VIWE.replace(':id', data.id)}
                      // to={{
                      //   pathname:PATHS.PROPERTIES_VIEW.,
                      //   state:{ data:data}
                      // }}
                    >
                      {data.title}
                    </Link>
                  )


                    },
                // }, {
                //   // xsHide:true,
                //   label: 'Description',
                //    accessor: 'description',
                //   cell: data => (
                //     <div dangerouslySetInnerHTML={{__html:data.description }} />
                //    )
                // },
                {
                  label: 'Property',
                  accessor: 'propertyName',
                },
                {
                  label: 'Announcement Date',
                  cell: data => (
                    convertLocalTime(data.announcementDate)
                    
                  )
                },
                 {
                  // xsHide: true,
                  cell: data => (
                    user.roles[0].role.name !== "Realtor" && <Hidden>
                    {/* <Button
                      color="semantic"
                      label={(
                        <Icon
                          glyph="pencil"
                          weight="light"
                        />
                      )}
                      onClick={() => {
                          setAnnouncementFormData(data)
                        this.setState({ showOverlay: true })}}
                    /> */}
                    {this.props.user.roles[0].role.name === 'Home Owner' ? null : <Button
                      color="semantic"
                      onClick={() => window.confirm(`Are you sure you want to delete Announcement`) && onDeleteAnnouncement(data)}
                      label={(
                        <Icon
                          glyph="trash"
                          weight="light"
                        />
                      )}
                    />}
                  </Hidden>
                  )
                }
              ]}
              data={announcements}
            />
          </>
        ) : (
          <Empty
            direction="ttb"
            headline="No Announcements yet"
            strapline="All Announcements you add will be listed here so it’s easier for you to manage."
            searchIsActive={search && search.announcements ? search.announcements : ''}
            cta={(
              user && (user.roles[0].role.name === 'Admin' || user.roles[0].role.name === 'Super Admin'||  user.roles[0].role.name === 'Property Developer') ?
              <Button
                color="teal"
                label="Add Announcement"
                onClick={() => {
                  setAnnouncementFormData({
                    title:'',
                    description:'',
                    propertyId: null,
                    attachments: []
                  })
                  this.setState({ showOverlay: true })}}
                icon={(
                  <Icon
                    glyph="building"
                    weight="light"
                    size="small"
                  />
                )}
                size="small"
              />
              : null
            )}
            image={(
              <img
                alt="No Announcements yet"
                src="/assets/empty/properties.svg"
              />
            )}
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={(
            <AnnouncementForm
              onClose={() => {
                this.setState({ showOverlay: false },() => clearAnnouncementFormData())}}
                onSaveAnnouncements={onSaveAnnouncements}
            />
          )}
        />
          <Overlay
          showOverlay={showAnnouncementOverlay}
          content={(
            <Announcementsview
            data={this.state.announcementData}
              onClose={() => {
                this.setState({ showAnnouncementOverlay: false })}}
            />
          )}
        />
      </>
    );
  }
}

 

const mapStateToProps = (state, ownProps) => ({

  search: selectSearch(state),
  user:selectAuthenticatedUser(state),
  loader: selectPRLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  setAnnouncementFormData,
  clearAnnouncementFormData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementsTable);
